import { useAuthParticipent } from "~/store/authParticipants";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const hasNoAuth = to?.meta?.noAuth;
    const auth = hasNoAuth ? useAuthParticipent() : useAuth();
    const config = useRuntimeConfig();
    if (auth?.account?.account_status === 'SUSPENDED') {
        if (!hasNoAuth) {
            return navigateTo('/hub/suspended');
        } else {
            return navigateTo(`${config.public.primaryURL}/login?account_suspended=true`, {external: true});
        }
    }
});
